import React, { useEffect, useState, useContext, useRef } from 'react';
import '@honorlock/integration-sdk-js';
import { Spinner } from 'src/components/Spinner';
import { Api } from 'src/helpers/new';
import { Button } from 'react-bootstrap';
import { withRouter } from 'src/hoc/withRouter';
import CourseContext from 'src/pages/Course/CourseContext';
import './Honorlock.scss';

function Honorlock(props: any) {
    const [iFrameUrl, setIFrameUrl] = useState('');
    const [isExtensionVerified, setIsExtensionVerified] = useState(false);
    const [instructionLoaded, setInstructionLoaded] = useState(false);
    const context = useContext(CourseContext);
    const isPageRedirectedToExam = useRef(false);

    useEffect(() => {
        if (window.Honorlock.isInitialized) {
            window.Honorlock?.examClosed();
        }
        window.Honorlock?.init()
            .then(() => {
                window.Honorlock?.onExtensionVerified(onExtensionVerified);

                //does not work
                window.Honorlock?.onExtensionRemoved(onExtensionRemoved);
                window.Honorlock?.onExtensionOffline(onExtensionOffline);
                window?.Honorlock.onBeginExam(OnBeginExam);
            })
            .catch((e) => {
                console.log('insided err', e);
            });

        (async () => {
            await getExtensionUrl();
        })();

        return () => {
            if (!isPageRedirectedToExam.current) {
                // Perform cleanup here
                if (window.Honorlock.isInitialized) {
                    window.Honorlock?.examClosed();
                }
            }
        };
    }, []);

    const getExamInstruction = async () => {
        setIFrameUrl('');
        const { success, response } = await Api.call('POST', `proctoring/honorlock/get-exam-instructions`, {
            userCourseId: context.course._id,
            courseId: context.course.courseId,
        });

        if (!success) {
            props.navigate(`/courses/${context.course?._id}/exam-summary`, { replace: true });
        }

        if (success) {
            window.Honorlock.setupSession({
                session: response.sessionInfo,
                app_url: process.env.REACT_APP_URL ?? 'http://localhost:3001/',
                external_exam_id: response.externalExamId,
                exam_taker_id: response.examTakerId,
                exam_taker_name: response.examTakerName,
                exam_taker_attempt_id: response.examTakerAttemptId,
            });

            setInstructionLoaded(true);
            setIFrameUrl(response.launch_screen_url);

            context?.updateCourseInfo?.('honorlockTempInfo', {
                sessionId: response.sessionInfo?.session?.uuid,
                examId: response.examTakerAttemptId,
            });
        }
    };

    const getExtensionUrl = async () => {
        const { success, response } = await Api.call('POST', `proctoring/honorlock/extension-check`);

        if (success && response) {
            setIFrameUrl(response.iframe_src);
        }

        if (!success) {
            props.navigate(`/courses/${context.course?._id}/exam-summary`, { replace: true });
        }
    };

    const onExtensionVerified = async () => {
        setIsExtensionVerified(true);
    };

    const onExtensionOffline = async () => {
        console.log('onExtensionOffline Handlation heree.');
    };

    const onExtensionRemoved = async () => {
        console.log('onExtensionRemoved Handlation heree.');
    };

    const OnBeginExam = async () => {
        //code for naviaget to exam screen..
        isPageRedirectedToExam.current = true;
        props.navigate(`/courses/${context.course?._id}/exam`, { replace: true });
    };

    return (
        <>
            {iFrameUrl ? (
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    {!instructionLoaded && (
                        <Button
                            className='bp honorlock-start-exam-btn'
                            disabled={!isExtensionVerified}
                            onClick={
                                isExtensionVerified
                                    ? async () => {
                                          getExamInstruction();
                                      }
                                    : () => {}
                            }
                        >
                            Start Exam
                        </Button>
                    )}
                    <iframe className='honorlock-iframe' title='honorlock-iframe' src={iFrameUrl} onLoad={() => {}} />
                </div>
            ) : (
                <Spinner />
            )}
        </>
    );
}

export default withRouter(Honorlock);
